import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SptRecorderService} from '@spout/global-web/data-access';

@Component({
  selector: 'spt-help-gain-content',
  templateUrl: './help-gain-content.component.html',
  styleUrls: ['./help-gain-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpGainContentComponent {
  constructor(private _recorder: SptRecorderService) {}
  refresh(): void {
    this._recorder.refreshAudioDeviceList().subscribe(() => {});
  }
}
